import { utilityService } from './../services/utility/utility.service';
import { PubSubService } from './../service/pubSub.service';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core'
import { socialService } from '../services/social/social.service';


@Component({
  selector: 'bh-products',
  templateUrl: './products.template.html'
})

export class productsComponent implements OnInit, OnChanges, OnDestroy {

  @Input('tabChange') tabChange; // current tab selected index

  productsDataArr: any=[]; // the array of object which forms the card list view
  options; // global config for the line graph on each card
  selectedCategoryName = 'products'; // default selected option in products component view
  getDataSub; // Subscription variable for pubsub for global dashboard service call timer

  /**
   * @param sService for getting products data
   * @param pubsub for subscribing to the getData event
   */
  constructor(private sService: socialService, private pubsub: PubSubService, private utilityS: utilityService) {
    this.productsDataArr = [];
    /**
    *  Subscribe to the getData event
    */
    this.getDataSub = this.pubsub.$sub('getData', (eventObject) => {
      this.getSetimentsByCategory();
    })
  }

  /**
   * 1. Initialize config options for line chart
   * 2. getSentiments data service call
   */
  ngOnInit() {

    /**
     * The default configuration for graph displayed in each card
     */
    this.options = {
      animation: {
        duration: 0
      },
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        xAxes: [{
          display: false,
          gridLines: {
            display: false,
            drawBorder: false
          }
        }],
        yAxes: [{
          display: false,
          gridLines: {
            display: false,
            drawBorder: false
          }
        }]
      },
      elements: {
        line: {
          tension: 0
        }
      },
      tooltips: {
        enabled: false
      }
    }

    /**
     * get the sentiments data by category on initialization
     * of the component
     */
    this.getSetimentsByCategory();
  }

  ngOnChanges(changes: SimpleChanges) {
    // products is the second tab in the tab group so it's currentIndex or currentValue == 1
    if (changes['tabChange'] && changes['tabChange'].currentValue === 1) {
      this.utilityS.applyConditionalCss();
      this.getSetimentsByCategory();
    }
  }

  /**
   * Gets called everytime the selected option for the card view
   * should be changed
   * @param selectedName Current selected option string
   */
  selectedChange(selectedName) {
    this.selectedCategoryName = selectedName;
    this.getSetimentsByCategory();
  }

  /**
   * Method for doing the necessary initialization before making
   * the service call
   */
  getSetimentsByCategory() {
    this.productsDataArr = [];
    if (this.selectedCategoryName) {
      this.sService.getSetimentsByCategory(this.selectedCategoryName).subscribe(result => {
        this.productsDataArr = result;
      })
    }
  }

  /**
   * 1. unsubscribe the timer before the component is destroyed
   */
  ngOnDestroy() {
    this.getDataSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/productsComponent/products.component.ts